<fullscreen-page>
    <content-column>
        <div class="d-flex flex-column flex-fill w-100 mx-auto overflow-hidden" slot="content">

            <div class="d-flex flex-column np-header">
                <div class="p-2 h2">Golden Record</div>
            </div>

            <div class="d-flex flex-row flex-grow-1 overflow-hidden">

                <div class="flex-grow-1 h-100 overflow-auto p-3">
                    <div class="d-flex flex-column gap-2 w-100">

                        <div *ngIf="goldenRecord"
                             class="catalog-row"
                             [class.catalog-row--selected]="selectedCatalogId === goldenRecord.catalogId"
                             (click)="onRowClick(goldenRecord.catalogId, goldenRecord.catalogName)">

                            <div class="catalog-row__drag">
                                <i class="dx-icon-menu"></i>
                            </div>

                            <i class="icon-glyphicons-basic-425-crown golden-record-crown"></i>

                            <div class="catalog-row__main">
                                <div class="catalog-row__title">
                                    {{ goldenRecord.catalogName }}
                                </div>
                                <div class="catalog-row__subtitle">
                                    {{ goldenRecord.createdAt | date:'dd.MM.yyyy, HH:mm' }}
                                </div>
                            </div>

                            <div class="catalog-row__actions" (click)="$event.stopPropagation()">
                                <dx-button
                                    icon="export"
                                    stylingMode="text"
                                    type="default"
                                    [hint]="'Katalog öffnen' | translate"
                                    (onClick)="openCatalog(goldenRecord.catalogId)">
                                </dx-button>
                                <dx-button
                                    icon="overflow"
                                    stylingMode="text"
                                    type="default"
                                    (onClick)="openGoldenRecordMenu($event, goldenRecord)">
                                </dx-button>
                            </div>
                        </div>

                        <ng-container *ngIf="goldenRecord && backups.length > 0">
                            <div class="catalog-row__subtitle fw-semibold px-1 pt-2">
                                {{ 'Backups' | translate }}
                            </div>

                            <div *ngFor="let backup of backups"
                                 class="catalog-row catalog-row--muted"
                                 [class.catalog-row--selected]="selectedCatalogId === backup.catalogId"
                                 (click)="onRowClick(backup.catalogId, backup.catalogName)">

                                <div class="catalog-row__drag">
                                    <i class="dx-icon-menu"></i>
                                </div>

                                <i class="dx-icon-clock"></i>

                                <div class="catalog-row__main">
                                    <div class="catalog-row__title">
                                        {{ backup.catalogName }}
                                    </div>
                                    <div class="catalog-row__subtitle">
                                        {{ backup.backUpTimeStamp | date:'dd.MM.yyyy, HH:mm' }}
                                    </div>
                                </div>

                                <div class="catalog-row__actions" (click)="$event.stopPropagation()">
                                    <dx-button
                                        icon="overflow"
                                        stylingMode="text"
                                        type="default"
                                        (onClick)="openBackupMenu($event, backup)">
                                    </dx-button>
                                </div>
                            </div>
                        </ng-container>

                        <div *ngIf="!goldenRecord" class="d-flex justify-content-center align-items-center p-5">
                            {{ 'Keine Golden Records vorhanden' | translate }}
                        </div>

                    </div>

                    <dx-context-menu
                        #rowMenu
                        [dataSource]="currentMenuItems"
                        [width]="200"
                        [showEvent]="''"
                        [position]="{ my: 'left top', at: 'left bottom' }"
                        (onItemClick)="onMenuItemClick($event)">
                    </dx-context-menu>
                </div>

                <np-inspect-panel
                    context="containerCatalog"
                    [catalogId]="selectedCatalogId"
                    [titleOverride]="selectedCatalogName">
                </np-inspect-panel>

            </div>
        </div>
    </content-column>
</fullscreen-page>
